<template>
  <div class="sr-contents-item">
    <div>
      <div>
        <iframe v-if="itemValue.youtube" :src="'https://www.youtube.com/embed/' + itemValue.youtube + '?rel=0&amp;controls=0&amp;showinfo=0'" frameborder="0" allowfullscreen width="100%"></iframe>
        <img v-else :src="itemValue.image" :alt="itemValue.title">
        <h4>{{ itemValue.title }}</h4>
        <ul
          v-if="itemValue.notes.length > 0"
          class="c-caution-list text-s margin-1em"
        >
          <li v-for="note in itemValue.notes">{{ note }}</li>
        </ul>
        <div :class="descriptionClassName" v-on:click="handleClick">
          <div class="js-collapsibleInner">
            <p v-html="itemValue.description"></p>
          </div>
        </div>
      </div>
      <div>
        <ul class="c-note-list text-s">
          <li>Supplier：{{ itemValue.supplier }}</li>
          <li class="c-note-list__item--nobullet">{{ itemValue.copyright }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import filter from 'lodash/filter';

export default {
  name: 'Item',
  props: ['itemValue'],
  computed: {
    descriptionClassName() {
      return filter([
        'sr-contents-item__descriptions',
        'text-s',
        this.itemValue.descriptionCollapsible ? 'vue-collapsible' : ''
      ]).join(' ');
    }
  },
  mounted() {
    if (this.itemValue.descriptionCollapsible) {
      const container = this.$el.querySelector('.vue-collapsible');

      if (this.$el.querySelector('.js-collapsibleInner').clientHeight >
          container.clientHeight) {
        container.classList.add('is-collapsible');
      }
    }
  },
  methods: {
    handleClick() {
      this.$el.querySelector('.vue-collapsible').classList.toggle('is-open');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/item.vue